module.exports = __webpack_public_path__ + "img/Huafeng_Xu.8845140d.png";